import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { candidateJobQueryKeys } from '@/modules/candidates/queries/queryKeys';
import { endpoints } from '@/modules/jobs/constants';
import type { ApiRequestBody } from '@/types/utils/request';
import { invalidateQuery } from '@/utils/queries';

type UploadCandidatesRequestBody = ApiRequestBody<
  typeof endpoints.uploadCandidates,
  'post'
>;

interface UploadCandidatesParams {
  jobId: string;
  body: UploadCandidatesRequestBody;
}

export const useUploadCandidatesMutation = () => {
  return useMutation({
    mutationFn: async ({ jobId, body }: UploadCandidatesParams) => {
      const { data } = await fetchClient.POST(endpoints.uploadCandidates, {
        params: { path: { jobId } },
        body,
      });
      return data;
    },
    onSettled: (_data, _error, variables) => {
      const { jobId } = variables;
      const listQueryKey = candidateJobQueryKeys.lists(jobId);

      invalidateQuery(listQueryKey)();
    },
  });
};
